import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'

import { useCurrentProductInformation } from '../hooks/useCurrentProductInformation.js'

export const AddonsCard = () => {
  const { hasPlan } = useCurrentProductInformation()
  const { Link } = useRouter()

  if (!hasPlan) {
    return null
  }

  return (
    <Card>
      <Card.Header
        title={<T defaultMessage="Add-ons" id="Admin.Billing.Addons" />}
        description={
          <T
            defaultMessage="Enhance your subscription with additional features to increase capacity and unlock new functionalities."
            id="Admin.Billing.AddonDescription"
          />
        }
      />
      <Card.Content>
        <Divider padding="none" className="-mx-6 mb-6" />
        <Link variant="accent" href="/manage/app-store/addons">
          <T
            defaultMessage="Manage add-ons"
            id="Admin.Billing.Addons.ManageAddons"
          />
        </Link>
      </Card.Content>
    </Card>
  )
}
